import React, { Component, Fragment } from 'react';
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import CloseActionButton from '../common/CloseActionButton';
import EditActionButton from '../common/EditActionButton';
import FormattedProperty from '../common/FormattedProperty';
import ListActionSubheader from '../common/ListActionSubheader';
import LoadingButton from "../../../shared/ui/LoadingButton";

class NotificationDetail extends Component {
  constructor(props) {
    super(props);
    this.state = { dropdownOpen: false };
  }

  // ----------------------
  // State setters
  // ----------------------

  toggleDropdown() {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        <div className="modal-body">
          <ListActionSubheader title={this.props.notification.name}>
            <EditActionButton label="Notification" onEdit={() => this.props.onEdit()} />
          </ListActionSubheader>
          <ul className="list-group list-group-flush mb-5">
            <li className="list-group-item">
              <FormattedProperty
                label="Description"
                value={this.props.notification.description}
              />
            </li>
            <li className="list-group-item">
              <FormattedProperty
                label="Subject"
                value={this.props.notification.subject}
              />
            </li>
            <li className="list-group-item">
              <FormattedProperty
                label="Content"
                value={this.props.notification.content}
              />
            </li>
          </ul>
          <ListActionSubheader title="Distribution">
            <Dropdown
              className="card-header-actions"
              isOpen={this.state.dropdownOpen}
              toggle={() => this.toggleDropdown()}
            >
              {this.props.notification && this.props.notification.getRolesNotInDistributionList().length ?
                <DropdownToggle className="action-button mr-3" nav>
                   <LoadingButton
                     primary
                     small
                     text={'Add'}
                     icon={'fa fa-plus'}
                     isLoading={this.props.isNotificationDistributionLoading}/>
                </DropdownToggle>
                : null
              }
              <DropdownMenu right>
                {this.props.notification && this.props.notification.getRolesNotInDistributionList().map((role, index) => (
                  <DropdownItem
                    key={index.toString()}
                    onClick={() => this.props.onAddToDistribution(role.scope)}
                  >
                    {role.name}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </ListActionSubheader>
          <ul className="list-group list-group-flush mb-5">
            {this.props.notification.getDistributionList().map((role, index) => (
              <li className="list-group-item property-list-item--with-actions" key={index.toString()}>
                <div>{role.name}</div>
                <LoadingButton
                  danger
                  small
                  text={'Remove'}
                  icon={'fa fa-trash'}
                  isLoading={this.props.isNotificationDistributionLoading}
                  onClick={() => this.props.onRemoveFromDistribution(role.scope)} />
              </li>
            ))}
          </ul>
        </div>
      </Fragment>
    );
  }

}

export default NotificationDetail;
